import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import useParams from '@/hooks/useParams';
import LearnerProfile from '@/modules/learner/views/LearnerProfile';

const LearnerProfilePage = () => {
  useTranslation(['LearnerProfile', 'Tags', 'Events']);
  const { learnerId } = useParams<{ learnerId: string }>();

  return <LearnerProfile learnerId={learnerId} />;
};

export default LearnerProfilePage;
